import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { t } from '../../../i18n';

const cancellationPoliciesApi = new Api('settings/cancellation_policies');

function* loadData() {
  try {
    const result = yield call(sendRequest, cancellationPoliciesApi.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data?.records) {
      yield put(actions.loadDataSuccess({ cancellationPolicyItems: result?.data?.success?.data?.records }));
    } else {
      yield put(actions.loadDataError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* createCancellationPolicies({ payload }) {
  try {
    const { data } = payload;
    const result = yield call(sendRequest, cancellationPoliciesApi.createItem, { data }, notifications.REQUEST_ERROR);

    if (result?.data) {
      yield put(actions.loadDataRequest());
      yield put(actions.createSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.created_successfully', {
            item: t('dash.agencies.viewAgency.cancellation_policy_section.section_header'),
          }),
        }),
      );
    } else {
      yield put(actions.createError({ data: { ...result } }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* editCancellationPolicies({ payload }) {
  try {
    const { data } = payload;
    const result = yield call(sendRequest, cancellationPoliciesApi.updateItem, { data }, notifications.REQUEST_ERROR);

    if (result?.data) {
      yield put(actions.loadDataRequest());
      yield put(actions.editSuccess());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.edited_successfully', {
            item: t('dash.agencies.viewAgency.cancellation_policy_section.section_header'),
          }),
        }),
      );
    } else {
      if (result?.base?.[0]) {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.error_headline'),
            type: 'error',
            message: result?.base?.[0],
          }),
        );
      }
      yield put(actions.editError({ data: { ...result } }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteRequest() {
  try {
    const result = yield call(sendRequest, cancellationPoliciesApi.deleteItem, {}, notifications.REQUEST_ERROR);

    if (result?.status === 200) {
      yield put(actions.deleteSuccess());
      yield put(actions.loadDataRequest());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.deleted_successfully', {
            item: t('dash.agencies.viewAgency.cancellation_policy_section.section_header'),
          }),
        }),
      );
    } else {
      yield put(actions.deleteError());
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_REQUEST, loadData),
    takeEvery(actions.CREATE_REQUEST, createCancellationPolicies),
    takeEvery(actions.EDIT_REQUEST, editCancellationPolicies),
    takeEvery(actions.DELETE_REQUEST, deleteRequest),
  ]);
}
